import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth/use-auth";

/**
 * Layout route: gate every child route behind a valid PAT. Redirects to `/`
 * with `replace: true` so the back button doesn't bounce back to a private
 * route after sign out.
 *
 * Placed in components/layout/ so the concern lives next to AppShell and
 * keeps route files free of auth-check boilerplate.
 */
export function RequireAuth() {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
}
